import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-circle-outline",
  "use": "icon-circle-outline-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-circle-outline\">\n    <title>icons/--icon-bg-circle-outline</title>\n    <g id=\"icon-circle-outline_icons/--icon-bg-circle-outline\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <circle id=\"icon-circle-outline_Oval\" stroke=\"#00519E\" stroke-width=\"2\" cx=\"12\" cy=\"12\" r=\"11\" />\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol